import { render, staticRenderFns } from "./fahuolist.vue?vue&type=template&id=24fc20e0"
import script from "./fahuolist.vue?vue&type=script&lang=js"
export * from "./fahuolist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports